import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import kgph from '../img/kgph.png';

const Catalog = ({ set_type }) => {
  const [photos, setPhotos] = useState([]);
  const [activeWedding, setActiveWedding] = useState(false);
  const [activeGraduation, setActiveGraduation] = useState(false);
  const [activeFamily, setActiveFamily] = useState(false);

  useEffect(() => {
    const fetchPhotos = async () => {
      try {
        let activeLink = '';
        if (set_type === 'wedding') {
          activeLink = 'wedding';
          setActiveWedding(true);
          setActiveGraduation(false);
          setActiveFamily(false);
        } else if (set_type === 'graduation') {
          activeLink = 'graduation';
          setActiveWedding(false);
          setActiveGraduation(true);
          setActiveFamily(false);
        } else if (set_type === 'family') {
          activeLink = 'family';
          setActiveWedding(false);
          setActiveGraduation(false);
          setActiveFamily(true);
        } else {
          activeLink = 'home';
          setActiveWedding(false);
          setActiveGraduation(false);
          setActiveFamily(false);
        }

        const axiosConfig = {
          withCredentials: true,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        };


        const response = await axios.get(`https://api.kgphotographies.com/api/getPhotoByType/${activeLink}`, axiosConfig);
        setPhotos(response.data);
        console.log(response.data);
      } catch (error) {
        console.error("Error fetching photos:", error);
      }
    };

    fetchPhotos();
  }, [set_type]);

  useEffect(() => {
    const showImages = () => {
      const imageElements = document.querySelectorAll('.fade-in-image');

      imageElements.forEach((image, index) => {
        setTimeout(() => {
          image.classList.add('show');
        }, index * 100); // Adjust the delay as needed
      });
    };

    showImages();
  }, [photos]);

  const renderPhotos = () => {
    return photos.map((photo) => (
      <div key={photo._id} className="photo-item">
        {photo.Add_Image && photo.Add_Image.data && photo.Add_Image.contentType ? (
          <img 
          src={`data:${photo.Add_Image.contentType};base64,${base64ArrayBuffer(photo.Add_Image.data.data)}`} 
          alt={photo.Photo_Name} 
          className="fade-in-image"
          />
        ) : (
          <p></p>
        )}
        <p>{photo.Photo_Name}</p>
        <p>{photo.description || ''}</p>
      </div>
    ));
  };

  const base64ArrayBuffer = (arrayBuffer) => {
    let binary = '';
    const bytes = new Uint8Array(arrayBuffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
  };

  return (
    <div>
      <div className="container">
        <header className="d-flex flex-wrap justify-content-around align-items-center py-3 mb-4 border-bottom">
          <a href="/login" className="d-flex align-items-center col-md-3 mb-2 mb-md-0 text-dark text-decoration-none ">
            <img src={kgph} className="img-fluid" alt="" />
          </a>
          <ul className="nav col-12 col-md-auto mb-2 justify-content-center mb-md-0">
            <li>
              <Link
                to="/"
                className={`nav-link px-2 ${activeWedding || activeGraduation || activeFamily ? 'link-dark fw-bold' : 'link-secondary'}`}
                onClick={() => {
                  setActiveWedding(false);
                  setActiveGraduation(false);
                  setActiveFamily(false);
                }}
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/wedding"
                className={`nav-link px-2 ${activeWedding ? 'link-secondary' : 'link-dark fw-bold'}`}
                onClick={() => {
                  setActiveWedding(true);
                  setActiveGraduation(false);
                  setActiveFamily(false);
                }}
              >
                Wedding
              </Link>
            </li>
            <li>
              <Link
                to="/graduation"
                className={`nav-link px-2 ${activeGraduation ? 'link-secondary' : 'link-dark fw-bold'}`}
                onClick={() => {
                  setActiveWedding(false);
                  setActiveGraduation(true);
                  setActiveFamily(false);
                }}
              >
                Graduation
              </Link>
            </li>
            <li>
              <Link
                to="/family"
                className={`nav-link px-2 ${activeFamily ? 'link-secondary' : 'link-dark fw-bold'}`}
                onClick={() => {
                  setActiveWedding(false);
                  setActiveGraduation(false);
                  setActiveFamily(true);
                }}
              >
                Family
              </Link>
            </li>
          </ul>
          <div className="col-md-3 text-end">
            <Link to="/calendar">
            <button type="button" className="btn custom-btn">
                <div className="p2">view</div>
                <div className="p2">schedule</div>
            </button>
            </Link>
          </div>
        </header>
      </div>
      <div className="photo-item d-flex justify-content-around align-items-center flex-wrap fade-in-image ">
        {photos && Array.isArray(photos) && photos.length > 0 ? (
          renderPhotos()
        ) : (
          <p></p>
        )}
      </div>
    </div>
  );
};

export default Catalog;